/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useState, useEffect, useContext, useCallback, useRef,
} from 'react';
import moment from 'moment';
import { motion } from 'framer-motion';
import { Link, useParams, useLocation } from 'react-router-dom';
import { distributorService } from '../../service/distributor.service';
import IndentListSkeleton from '../MISReports/IndentReport/indentlistSkeleton';
import Pagination from '../../Components/Pagination';
import SubscribersFilterModal from './subscribersFilterModal';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import HeaderContext from '../../Components/Context/HeaderContext';
import { GenerateDateandTime } from '../../redux/helper/DateConverter';

function ViewSubscribers() {
    const {
        SetSuccessMessage,
    } = useContext(HeaderContext);
    const { id } = useParams();
    const location = useLocation();
    const [subscribersList, setSubscribersList] = useState([]);
    const [sortType, setsortType] = useState('created_at+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [Filter, setFilter] = useState({
        status: [],
        type: [],
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [DealDetails, setDealDetails] = useState([]);

    const getDetails = useCallback(
        async () => {
            const OfferDetals = await distributorService.ViewBulkOffer(id);
            if (!OfferDetals.error && OfferDetals.data.success_status) {
                setTimeout(() => {
                    setDealDetails(OfferDetals.data.data);
                }, 500);
            }
        },
        [id],
    );

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleFetchBulkOfferSubscribers = useCallback((() => {
        distributorService.BulkOfferSubscribersList(id, currentPage, sortType, debouncedSearch, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setSubscribersList(response.data.data.Items);
                setalldata(response);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, debouncedSearch, sortType, filterValue]);

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleExport = useCallback((() => {
        distributorService.BulkOfferSubscribersList(id, currentPage, sortType, debouncedSearch, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage('File exported sucessfully!');
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchBulkOfferSubscribers();
    }, [handleFetchBulkOfferSubscribers]);

    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center top-0 left-0 pb-[18px]">
                <div className="flex items-center">
                    <Link to="/bulk-offers">
                        <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                    </Link>
                    <h5 className="text-xs4 font-normal text-[#555259]">Subscribers</h5>
                </div>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{ border: ' 2px solid #E9EDF4' }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu sm:min-w-[80px] min-w-[80px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[99] sm:p-3.5 p-1.5`} aria-labelledby="exportDropdown" style={{ zIndex: '99' }}>
                            <li className=" sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a
                                    className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className=" sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a
                                    className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"
                                    href="#"
                                    onClick={() => setexportSelected('pdf')}

                                >
                                    PDF

                                </a>
                            </li>
                            <li className=" sm:py-1 py-0.5">
                                <a
                                    onClick={() => setexportSelected('excel')}
                                    className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"
                                    href="#"
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <p className="text-base font-semibold pb-[15px] text-[#808285] ml-[34px]">
                Bulk offer Code:
                {' '}
                <span className="text-[#090406]">{id}</span>
            </p>
            {loading ? <IndentListSkeleton /> : (
                <div>
                    {subscribersList.length > 0 && (
                        <div className="overflow-auto dropdown-menu pb-7 relative z-[2]" style={{ height: 'calc(100vh - 337px)' }}>
                            <table className="w-full table-auto relative">
                                <thead className="top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-4 px-6 rounded-bl-lg rounded-tl-lg min-w-[142px] text-start" scope="col">
                                            <span className="text-sm29 font-bold text-[#FFFFFF]">
                                                Distributor ID
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[158px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Subscription  ID
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[182px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Subscription  Date
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[190px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Distributor Name
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'CREATED_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'CREATED_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'CREATED_DATE+asc') {
                                                                setsortType('CREATED_DATE+desc');
                                                            } else if (sortType === 'CREATED_DATE+desc') {
                                                                setsortType('CREATED_DATE+asc');
                                                            } else {
                                                                setsortType('CREATED_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[108px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Type
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'offer_type+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'offer_type+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'offer_type+asc') {
                                                                setsortType('offer_type+desc');
                                                            } else if (sortType === 'offer_type+desc') {
                                                                setsortType('offer_type+asc');
                                                            } else {
                                                                setsortType('offer_type+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[180px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Offer Status
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'status+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'status+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'status+asc') {
                                                                setsortType('status+desc');
                                                            } else if (sortType === 'status+desc') {
                                                                setsortType('status+asc');
                                                            } else {
                                                                setsortType('status+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[100px] text-start rounded-tr-lg rounded-br-lg ">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Action
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subscribersList.length > 0 && subscribersList.map((item) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {item?.distributor_id}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {item?.subscription_id}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {GenerateDateandTime(item?.created_at)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {item?.party_name}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-center">
                                                {item?.offer.industrial_pocket}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {(moment(moment(moment.now()).format('DD/MM/YYYY')) > moment(moment(new Date(DealDetails.end_date)).format('DD/MM/YYYY'))) ? <p> Expired</p> : <p>Active</p> }
                                            </td>
                                            <td className="py-4 px-7">
                                                <Link to={`/bulk-offers/subscribered-orders/${item.subscription_id}/${item?.distributor_id}`} className="flex justify-center items-center px-2.5 py-[5px] bg-[#44445E] rounded w-fit text-xs font-normal text-[#fff]">
                                                    View
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && subscribersList && subscribersList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {filterModal && (
                        <SubscribersFilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            setfilterValue={setfilterValue}
                            Filter={Filter}
                            setFilter={setFilter}
                            handleFilter={handleFilter}
                            handleFetchBulkOfferSubscribers={handleFetchBulkOfferSubscribers}
                        />
                    )}
                    {emptyData && (
                        <EmptyScreen
                            search="yes"
                            text="no Subscribers"
                            buttonRequired={false}
                            all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                        />
                    )}
                </div>
            )}

        </div>
    );
}

export default ViewSubscribers;
